import { Pipe, PipeTransform, SecurityContext, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'breakLine',
  standalone: true,
})
export class BreakLinePipe implements PipeTransform {
  private domSanitizer = inject(DomSanitizer);

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() { }

  transform(value: any, addBreakLine: boolean = true): any {
    return this.domSanitizer.sanitize(
      SecurityContext.HTML,
      this.domSanitizer.bypassSecurityTrustHtml(this.stylize(value, addBreakLine)),
    );
  }

  private stylize(text: string, addBreakLine: boolean = true): string {
    if (text && text.length > 0) {
      text = text.replace('\\n', addBreakLine ? '<br/>' : ' ');
      return `${text} `;
    } else return text;
  }
}
